module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.5136cbe6.woff2";